import { render, staticRenderFns } from "./default-demo.vue?vue&type=template&id=f85a71ba&scoped=true&"
import script from "./default-demo.vue?vue&type=script&lang=js&"
export * from "./default-demo.vue?vue&type=script&lang=js&"
import style0 from "./default-demo.vue?vue&type=style&index=0&id=f85a71ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a71ba",
  null
  
)

export default component.exports